import { useQuery } from "@tanstack/react-query";
import { PortfolioKeys } from "web_myplann/Api/Portfolio/portfolioKeys";
import {
	type ClientPortfolioDomainEnum,
	getPortfolioDomainProductCategoriesV2,
} from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";

export const usePortfolioProductCategoriesQuery = (
	portfolioType: ClientPortfolioDomainEnum | undefined,
) => {
	return useQuery({
		queryKey: PortfolioKeys.productCategories(portfolioType!),
		queryFn: processResponse(() =>
			getPortfolioDomainProductCategoriesV2(portfolioType!),
		),
		enabled: Boolean(portfolioType),
	});
};
